/* eslint-disable react/require-default-props */
import React from 'react';
import { AcademyLive } from 'store/modules/academy_store/types';
import { academyDay, academyMonthAbbr } from 'services/academy_date';
import { Container } from './styles';

interface AcademyEventRowProps {
  live: AcademyLive;
  action: React.ReactNode;
  onOpen?: () => void;
}

const AcademyEventRow: React.FC<AcademyEventRowProps> = ({ live, action, onOpen }) => {
  const isRecording = live.status === 'finished';

  return (
    <Container
      className={onOpen ? 'clickable' : ''}
      onClick={onOpen}
      role={onOpen ? 'button' : undefined}
    >
      <div className="date-box">
        <span className="day">{academyDay(live.scheduled_at)}</span>
        <span className="month">{academyMonthAbbr(live.scheduled_at)}</span>
      </div>

      <div className="content">
        <div className="content-top">
          <div className="titles">
            <div className="title">{live.title}</div>
            {live.speaker && <div className="subtitle">{live.speaker}</div>}
          </div>
          <div
            className="action"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="presentation"
          >
            {action}
          </div>
        </div>
        <div className="badges">
          <span className="badge-pill">
            <i className="material-icons">{isRecording ? 'videocam' : 'notifications'}</i>
            {isRecording ? 'Gravação' : 'Live'}
          </span>
          {live.category && <span className="badge-pill">{live.category}</span>}
        </div>
      </div>
    </Container>
  );
};

export default AcademyEventRow;
